export const CREDIT_NOTE_STATUS_OPTIONS = [
  { value: "issued", label: "Issued" },
  { value: "void", label: "Void" },
] as const;

export function creditNoteStatusLabel(status: string): string {
  if (status === "issued") return "Issued";
  if (status === "void") return "Void";
  return status;
}
